import {useState} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Accordion} from 'shared/components';

const EventPill = observer(({event, emojiReady}) => {
  return (
    <div className={`WhatsGoingOn-pill WhatsGoingOn-pill--${event.pillStyle}`}>
      <span className='WhatsGoingOn-dot'/>
      {emojiReady && event.emojiKey && <span className='WhatsGoingOn-pillEmoji'>
        <em-emoji id={event.emojiKey} set='native' size='14px'></em-emoji>
      </span>}
      <span className='WhatsGoingOn-pillTitle'>{event.title}</span>
    </div>
  );
});

const EventRow = observer(({event, emojiReady}) => {
  return (
    <div className='WhatsGoingOn-row'>
      <EventPill event={event} emojiReady={emojiReady}/>
      <div className='WhatsGoingOn-time'>
        {event.allDay ?
          <FormattedMessage id='hr_dashboard.whats_going_on.All day'/> :
          event.timeLabel}
      </div>
    </div>
  );
});

const EventGroupRow = observer(({group, emojiReady}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className='WhatsGoingOn-group'>
      <div
        className='WhatsGoingOn-row clickable user-select-none'
        onClick={() => setExpanded(!expanded)}
      >
        <div className={`WhatsGoingOn-pill WhatsGoingOn-pill--${group.pillStyle}`}>
          <span className='WhatsGoingOn-dot'/>
          {emojiReady && group.emojiKey && <span className='WhatsGoingOn-pillEmoji'>
            <em-emoji id={group.emojiKey} set='native' size='14px'></em-emoji>
          </span>}
          <span className='WhatsGoingOn-pillTitle'>
            <FormattedMessage id={group.titleId} values={{count: group.count}}/>
          </span>
          <i className={`material-symbols-solid WhatsGoingOn-groupChevron ${expanded ? 'expanded' : ''}`}>
            {'chevron_right'}
          </i>
        </div>
      </div>
      <Accordion active={expanded}>
        <div className='WhatsGoingOn-groupEvents'>
          {group.events.map(event =>
            <EventRow key={event.key} event={event} emojiReady={emojiReady}/>)}
        </div>
      </Accordion>
    </div>
  );
});

const Row = observer(({row, emojiReady}) => {
  return row.rowType === 'group' ?
    <EventGroupRow group={row} emojiReady={emojiReady}/> :
    <EventRow event={row} emojiReady={emojiReady}/>;
});

const EventList = observer(({agenda, emojiReady}) => {
  return (
    <div className='WhatsGoingOn-events'>
      {agenda.rows.map(row => <Row key={row.key} row={row} emojiReady={emojiReady}/>)}
    </div>
  );
});

export default EventList;
